export const PROFILE_BLOCK_HEIGHT = 71;
export const FIELDS_HORIZONTAL_GUTTER = 2;
export const STEP_CONTENT_VERTICAL_GUTTER = 3;
export const STEP_CONTENT_HORIZONTAL_GUTTER = [4, 5];
export const STEP_CONTENT_HORIZONTAL_GUTTER_NEGATIVE = [-4, -5];
